import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{						
						case 'anularRegistroFtn':
							await this.updateDataForm({state:'info_ingresos/fecha', data: this.fecha().fecha.minHoy})
							await this.updateDataForm({state: 'info_ingresos/anulado', data: 1})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: this.dataForm[this.namePath].info_ingresos.nota_delete, 
									tablaPost: ['info_ingresos'],
									tablaDelete:[]
								}
							}) 
							 
						break;			
						case 'descargarAflFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_ingresos'],
									tablaDelete:[]
								}
							}) 
							 
						break;						
					}
				}

				await this.save(event.save)
				
				const await30 =   this.getDataGet({route: 'get_afldescargar', data: {others: []}})
				// frotend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await await30
				await await31
				await await32
				await await33
				await await34
			}
			catch{

			}			
		}		
	},
}
